import React from "react";
import { AlertTriangle, RefreshCcw } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * ErrorState — surfaces structured API errors verbatim.
 *
 * Always renders the machine `code` in a mono chip alongside the human
 * message. This keeps the error searchable / debuggable for users and
 * support without leaking implementation detail.
 */
export function ErrorState({
  error, onRetry, title, className, "data-testid": testId,
}) {
  const code = error?.code || "UNKNOWN_ERROR";
  const message = error?.message || "Something went wrong.";
  return (
    <div
      role="alert"
      data-testid={testId || "error-state"}
      className={cn(
        "flex flex-col items-start gap-3 rounded border border-red-200 bg-red-50 p-4",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <AlertTriangle size={18} className="text-red-600" aria-hidden="true" />
        <h3 className="text-sm font-semibold text-red-900">
          {title || "Request failed"}
        </h3>
      </div>
      <div className="text-sm text-red-800">{message}</div>
      <div className="flex items-center gap-2">
        <code
          data-testid="error-code"
          className="rounded bg-red-100 px-2 py-0.5 font-mono text-xs text-red-900"
        >
          {code}
        </code>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            data-testid="error-retry"
            className="inline-flex items-center gap-1 rounded bg-white px-2.5 py-1 text-xs font-medium text-red-900 ring-1 ring-red-200 hover:bg-red-100"
          >
            <RefreshCcw size={12} /> Retry
          </button>
        )}
      </div>
    </div>
  );
}
